<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Testimonials</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Testimonials</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="student-scholarship ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="outerdiv">
          <div class="innerdiv">
             <div class="div12 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/chaitanya-bhogawade.jpg" alt="Dnyanesh Gote | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Narendra Kadam</p>
                  <p class="designation">TY B.Sc (CS)</p>
                </div>
              </div>
              <div class="review">
                <p>“My journey in the B.Sc. Computer Science program has been both enriching and transformative. The college has provided excellent academic guidance and a supportive learning environment that encouraged me to explore my potential. I had the opportunity to enhance my skills through value-added courses offered by external organizations, which broadened my knowledge beyond the classroom. I am especially grateful for the placement opportunity I received as an Intern in Research, Monitoring, and Evaluation at VOPA. This experience has greatly contributed to my professional development and prepared me for future career challenges with confidence."</p>
              </div>
            </div>
            <div class="div15 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/aboli-dhumal.jpg" alt="Mr. Ashish Pandey | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Abolee Lalitkumar Dhumal</p>
                  <p class="designation">TY B.Sc (CS 2022-25)</p>
                </div>
              </div>
              <div class="review">
                <p>I am incredibly grateful to have spent my Bachelor’s of Computer Science journey at G H Raisoni College of Arts,Commerce and Science, Wagholi,Pune. The past three years have been truly transformative, not only in terms of academic learning but also in personal growth and professional development.</p>
                <p>The faculty here has been exceptionally supportive and student-friendly. Their dedication, approachable nature, and commitment to helping us succeed have had a lasting impact on my learning experience. Whether it was subject doubts, project guidance, or career advice, the teachers always made time to guide us with patience and clarity.</p>
                <p>I also want to extend my sincere thanks to the Training and Placement Cell. The various workshops and industry-driven training sessions prepared me with essential skills and confidence. Their continuous efforts helped me secure a job opportunity at Accenture.</p>
                <p>Thank you for shaping my career.</p>
              </div>
            </div>
            <div class="div13 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/narendra-kadam.jpg" alt="Ms. Pragati Jadhav | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name dark"> Chaitanya Bhogawade</p>
                  <!-- <p class="designation dark">SY BBA</p> -->
                </div>
              </div>
              <div class="review dark">

              <p>My experience at G.H. Raisoni College of Arts, Commerce and Science has been truly positive. The faculty is supportive, the environment is friendly, and the campus offers great opportunities for learning and growth. Activities, workshops, and events help build confidence and skills. I am proud to be part of this college, which has shaped me both academically and personally.  </p>
            </div>
            </div>
            <div class="div1 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/dnyanesh-gote.webp" alt="Dnyanesh Gote | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Mr. Dnyanesh Gote</p>
                  <p class="designation">TY B.Sc (CS)</p>
                </div>
              </div>
              <div class="review">
                <p>My sincere appreciation & gratitude to the Training & Placement Department and all staffs of the
                  College for their efforts in imparting quality technical and aptitude training. I am very grateful to
                  them for effectively and sincerely helping me to grab first ever opportunity i.e Wipro.</p>
              </div>
            </div>
            <div class="div2 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/ashish-pandey.webp" alt="Mr. Ashish Pandey | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Mr. Ashish Pandey</p>
                  <p class="designation">SY BBA (CA)</p>
                </div>
              </div>
              <div class="review">
                <p>“The College has well-educated and qualified faculties to help students in their career guidance.
                  GHRCACS College provides us different seminars and webinars to enhance our skills as well as they help
                  us in many ways. The college is too good and campus is well equipped with amenities and good learning
                  atmosphere. All staff Members including HOD, Principal and Teachers are friendly in nature.”</p>
              </div>
            </div>
            <div class="div3 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/pragati-jadhav.webp" alt="Ms. Pragati Jadhav | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name dark">Ms. Pragati Jadhav</p>
                  <p class="designation dark">SY BBA</p>
                </div>
              </div>
              <div class="review dark">
                <p>The College creates a student-friendly atmosphere with experience in different fields, the teaching
                  staff is responsive, attentive and passionate about the subject. When a student has a problem, the
                  teacher would walk to their desk and help the student. The standard of education the faculty provides
                  alongside gaining knowledge within the field is something not every college can provide. The college
                  is very supportive, and tuition fee is affordable. Other than the studies there are many events
                  organized by the college for the students which are not only enjoyable but also helpful for the
                  development of an individual. It is indeed a great place to embrace your talent and intelligence.</p>
              </div>
            </div>
            <div class="div4 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/deepali-sahu.webp" alt="Ms. Deepali Sahu | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name dark">Ms. Deepali Sahu</p>
                  <p class="designation dark">TY BBA (CA)</p>
                </div>
              </div>
              <div class="review dark">
                <p>I loved the Infrastructure of G.H.Raisoni College of Arts, Commerce and Science. The events that I
                  took part helped me to grow my confidence level. I would like to specially thank the teaching staff
                  for guiding me and good knowledge for my carrier. Being involved in college activities also helped me
                  to create some meaningful memories at Raisoni College and
                  connect me with a people.
                </p>
              </div>
            </div>
            <div class="div5 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/nishant-devekar.webp" alt="Nishant Devekar | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Mr. Nishant Devekar</p>
                  <p class="designation">SY BBA (CA)</p>
                </div>
              </div>
              <div class="review">
                <p>“G.H.Raisoni College of arts, commerce and science is one of the most renowned colleges in Pune. The
                  ambience is soothing and calm. The teaching staff is accessible to the students all the time. The
                  college does have many numbers of activities organized as a part of their curriculum. College believes
                  in sport activities and motives the students to participate in them. The course I'm studying is very
                  interesting. As the college conducts many extra-curricular activities which make students very
                  skillful and knowledgeable.”</p>
              </div>
            </div>
            <div class="div6 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/dhruv-prajapati.webp" alt="Mr. DHRUV PRAJAPATI | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Mr. DHRUV PRAJAPATI</p>
                  <p class="designation">S.Y. B.Sc. (CS)</p>
                </div>
              </div>
              <div class="review">
                <p>As a student of BSc.(CS) in G.H.Raisoni College of Arts, Commerce and Science, Pune, I gained both
                  the skills and confidence to thoughfully use a variety of quantitative approaches in the work. I also
                  got good support during the online classes and great support from the teachers during the pandemic
                  time. Also the faculty are extremely responsive to student questions and needs. Overall, I had good
                  time to focus on my coding in the college.</p>
              </div>
            </div>
            <div class="div7 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/kishi-kothari.webp" alt="Ms. Kishi Kothari | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Ms. Kishi Kothari</p>
                  <p class="designation">SY B.Com.</p>
                </div>
              </div>
              <div class="review">
                <p>G. H. Raisoni College of Arts, Commerce & Science, Wagholi, Pune is a highly recommended college of
                  Pune as it provides higher degree of knowledge through their learned faculties and offers excellent
                  infrastructure facility with various opportunities for student, grooming through the conferences,
                  guest lectures, competitions, co-curricular sports meet, seminars & so forth.</p>
              </div>
            </div>
            <div class="div8 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/shivani-sagadeven.webp" alt="Ms. Shivani  Sagadeven | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Ms. Shivani Sagadeven</p>
                  <p class="designation">M. Com - I</p>
                </div>
              </div>
              <div class="review">
                <p class="text-dark">GHRCACS is one of the pre-eminent college in Pune. The college gives ethics and
                  good education with well Qualified and pooled faculties. The staff will be always available to solve
                  your queries, the HOD, Vice Principal and Principal are cordial, the management is well organized.
                  Besides education they organized seminars, workshops, guest lecture etc. to tailor students. It makes
                  the student more independent and Placements are guaranteed in our college. Top reputed companies visit
                  our college to hire students as interns for their companies. This college has a very good
                  infrastructure with proper lab, library and hostel facility.</p>
              </div>
            </div>
            <div class="div9 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/sheetal-chavan.webp" alt="Mr. Sheetal Chavan | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Ms. Sheetal Chavan</p>
                  <p class="designation">TY B.Com.</p>
                </div>
              </div>
              <div class="review">
                <p>To achieve excellent standards of quality education, choose G.H.RCACS. The College teachers are
                  friendly with every student and their way of teaching is very good. They are very helpful and even
                  take care and focus on each student separately. The classrooms and library are well-maintained. As a
                  B.Com student all my subject teachers supported me in my studies, cleared my doubts from time to time.
                  This College provides best secure environment to the students. College contains Anti Ragging
                  Committee. College works with affiliation of SPPU and it is also ‘A’ graded by NAAC with score3.22.Its
                  fee structure is very decent so that students from all sections of financial condition can do their
                  studies here.</p>
              </div>
            </div>
            <div class="div7 eachdiv">
              <div class="userdetails">
                <div class="imgbox">
                  <img src="{{baseUrl}}/testimonials/kaustubh-deochake.webp" alt="Mr. Kaustubh Deochake | GHRCACS, PUNE">
                </div>
                <div class="detbox">
                  <p class="name">Mr. Kaustubh Deochake</p>
                  <p class="designation">M.Sc. (CS) – I</p>
                </div>
              </div>
              <div class="review">
                <p>I have completed my 12th in science field then I enrolled in GHRCACS for my graduation in B.Sc. (CS)
                  through this institute. The faculties are very supportive. There are many other activities of all
                  students. Therefore I continued my post graduation in M.Sc. (CS) from same college.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
